<div [ngStyle]="{'width': getWidth(card_format), 'margin-left': getMargin(card_format)}">
    {{index + 1}}. <ng-katex-paragraph [paragraph]="exercise?.text | exerciseFormat"></ng-katex-paragraph>
</div>




